<template>
  <div>
    <span class="label"> {{ label }}</span>
    <span class="label label--details">
      ({{ totalSubElements }} {{ SEARCH_WORLD_ELEMENT_TYPES[world].subElementTypeLabel }} -
      {{ totalElements }} {{ SEARCH_WORLD_ELEMENT_TYPES[world].elementTypeLabel }})
    </span>
  </div>
</template>

<script>
  import { SEARCH_WORLD_ELEMENT_TYPES } from '@/constants'

  export default {
    name: 'SearchSummaryTotalElementsLabel',
    props: {
      label: {
        type: String,
        required: true
      },
      totalElements: {
        type: Number,
        required: true
      },
      totalSubElements: {
        type: Number,
        required: true
      },
      world: {
        type: String,
        required: true
      }
    },
    computed: {
      SEARCH_WORLD_ELEMENT_TYPES() {
        return SEARCH_WORLD_ELEMENT_TYPES
      }
    }
  }
</script>

<style lang="scss" scoped>

  .label {
    color: $mi-silver-700;
    font-feature-settings: "clig" off, "liga" off;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 17px;
  }

  .label:first-child {
    margin-right: 14px;
  }
</style>
